
const prefix: string = "ut_jm_ai_"

export function add_table_prefix(table: string) {
    if (table.indexOf("ut_jm_ai_")!=0) {
      return prefix+table.trim()
    }
    return table.trim()
  }
  
  export function remove_table_prefix(table: string) {
    return table.replace(prefix,"")
  }
